Vue.component('edit-response-placeholders', {
  template: `
    <div>
      <div class="d-flex flex-wrap justify-content-end align-items-center mb-3">
        <span class="header-case">Placeholders for language</span>
        <select v-model="currentLanguage" @change="setValues">
          <option v-for="option in options" :value="option">{{ langCodeToLabel(option) }}</option>
        </select>
      </div>
      <table class="w-100 mb-3" v-show="currentPlaceholders != null">
        <tr>
          <td class="p-3" scope="row">Property Name</td>
          <td><input class="form-control" type="text" name="" v-model="placeholders.hotel_name"/></td>
        </tr>
        <tr>
          <td class="p-3" scope="row">Location Name</td>
          <td><input class="form-control" type="text" name="" v-model="placeholders.location_name"/></td>
        </tr>
        <tr>
          <td class="p-3" scope="row">Signature</td>
          <td><textarea class="form-control" type="text" name="" v-model="placeholders.signature"/></td>
        </tr>
      </table>
      <div class="text-right">
        <button class="btn btn-primary" @click="savePlaceholders">Save Settings for {{ langCodeToLabel(currentLanguage) }}</button>
      </div>
    </div>
  `,
  props: ['team_id', 'team'],
  watch: {
    team_id: function(newVal, oldVal) {
      // null placeholders to force "loading" sequence 
      this.currentPlaceholders = null
      this.getCurrentPlaceholders()
    }
  },
  data() {
    return {
      placeholders: {
        hotel_name: '',
        location_name: '',
        signature: ''
      },
      currentLanguage: 'en',
      options: [
        'en',
        'nl',
        'de',
        'el',
        'tl',
        'it',
        'es',
        'af',
        'am',
        'ar',
        'bg',
        'cs',
        'fr',
        'pt',
        'sw',
        'sv',
        'tr',
        'ro',
        'ru',
        'uk'
      ],
      currentPlaceholders: null,
      defaults: null
    }
  },
  mounted() {

    this.getCurrentPlaceholders()

  },
  methods: {
    getCurrentPlaceholders() {
      axios.get(`/api/settings/${this.team_id}/${Spark.state.user.id}/placeholders`)
      .then(response => {
        this.currentPlaceholders = response.data.placeholders
        this.defaults = response.data.defaults
        this.setValues()

      })
    },
    savePlaceholders(event) {
      let plc = {...this.placeholders}
      let payload = {}
      payload.placeholders = plc
      payload.language = this.currentLanguage

      axios.post(`/api/settings/${this.team_id}/${Spark.state.user.id}/placeholders`, payload)
      .then(response => {
        this.currentPlaceholders = response.data.placeholders
        this.setValues()
        swal("Awesome!", "Your new settings have been saved!", "success")
      })
    },
    setValues() {
      for (let placeholder in this.placeholders) {
        this.placeholders[placeholder] = this.getCurrentValue(placeholder)
      }
    },
    getCurrentValue(plc_type) {

      for (var plc of this.currentPlaceholders) {
        if (plc.type == plc_type && plc.language == this.currentLanguage) {
          return plc.value
        }
      }

      return this.defaults[plc_type]
    },
    launchSettings() {
      this.getCurrentPlaceholders()
      $(this.$refs.settings_modal).modal('toggle')
    }
  }
})